var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondashboardresidentExclamationpoint = function SvgIcondashboardresidentExclamationpoint(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "17px",
    viewBox: "0 0 4 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon.dashboard.resident_exclamationpoint") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon.dashboard.resident_exclamationpoint",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,11.2933709 C2.55953884,11.2933709 2.96240681,10.8857546 3.02955147,10.2383639 L3.99195828,1.22284908 C4.05910294,0.527503526 3.70099808,0 3.09669613,0 L0.903303867,0 C0.299001916,0 -0.0591029438,0.527503526 0.00804171742,1.22284908 L0.970448528,10.2383639 C1.03759319,10.8857546 1.44046116,11.2933709 2,11.2933709 Z M2,17 C3.11907769,17 3.94719518,16.112835 3.94719518,14.9619182 L3.94719518,14.9139633 C3.94719518,13.7630465 3.11907769,12.8758815 2,12.8758815 C0.880922313,12.8758815 0.0528048249,13.7630465 0.0528048249,14.9139633 L0.0528048249,14.9619182 C0.0528048249,16.112835 0.880922313,17 2,17 Z",
    id: "!",
    fill: "#EE3B0C",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondashboardresidentExclamationpoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.dashboard.resident_exclamationpoint.3149b200f4fb7f833aaa8f2d56b3a55a.svg";